export const PageHeader = ({ top, bottom, intro, testId }) => (
  <section className="relative pt-40 pb-16 border-b border-white/10 brand-glow grain overflow-hidden" data-testid={testId}>
    <div className="absolute inset-0 bg-[#0a0a0a]/45" />
    <div className="relative max-w-[1600px] mx-auto px-5 md:px-10 grid lg:grid-cols-[1.4fr_1fr] gap-10 items-end reveal">
      <h1 className="uppercase leading-[0.92] text-[10vw] sm:text-6xl lg:text-7xl xl:text-8xl break-words">
        <span className="block font-display text-white">{top}</span>
        {bottom && <span className="block pl-[8%] font-thin-brand text-white">{bottom}</span>}
      </h1>
      {intro && <p className="text-zinc-200 text-base sm:text-lg leading-relaxed max-w-xl">{intro}</p>}
    </div>
  </section>
);

export const Container = ({ children, className = "" }) => (
  <div className={`max-w-[1600px] mx-auto px-5 md:px-10 ${className}`}>{children}</div>
);

export const LoadingGrid = ({ count = 6 }) => (
  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="aspect-[5/3] bg-[hsl(var(--surface))] animate-pulse" />
    ))}
  </div>
);
